import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';
import { TaskPointsBadge } from '.';

const MultipleChoiceAnswer = ({ answers, maxScore, options, score }) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="answer">
      <div className="options">
        {options.map((option, i) => (
          <div className="option" key={i}>
            <div
              aria-label={
                option.correct
                  ? answers && answers.includes(i)
                    ? messages.commonCorrectAnswer
                    : messages.commonIncorrectAnswer
                  : options.find((option) => option.correct) &&
                    answers &&
                    answers.includes(i)
                  ? messages.commonIncorrectAnswer
                  : null
              }
              className="option-icon"
            >
              <Icon
                icon={
                  answers && answers.includes(i)
                    ? 'check-square'
                    : ['far', 'square']
                }
                fixedWidth={true}
                style={{
                  color:
                    answers && answers.includes(i)
                      ? theme.successStandaloneColor
                      : '#444'
                }}
              />
            </div>

            <div className="option-text">
              <div
                className="option-text-content"
                dangerouslySetInnerHTML={{ __html: option.text }}
              />
            </div>

            {options.some((option) => option.correct) ? (
              <div className="option-correct">
                {option.correct ? (
                  <div
                    aria-label={messages.readerMultipleChoiceCorrectOption}
                    data-tooltip={messages.readerMultipleChoiceCorrectOption}
                  >
                    <Icon
                      icon="check"
                      fixedWidth={true}
                      style={{ color: theme.successStandaloneColor }}
                    />
                  </div>
                ) : (
                  <div
                    aria-label={messages.readerMultipleChoiceIncorrectOption}
                    data-tooltip={messages.readerMultipleChoiceIncorrectOption}
                  >
                    <Icon
                      icon="times"
                      fixedWidth={true}
                      style={{ color: theme.dangerColor }}
                    />
                  </div>
                )}
              </div>
            ) : null}
          </div>
        ))}
      </div>

      <TaskPointsBadge
        hideSuccessBadge={!options.filter((option) => option.correct).length}
        maxPoints={maxScore}
        points={score}
      />

      <style jsx>{`
        .options {
          counter-reset: multiplechoice-option;
        }
        .option {
          background-color: white;
          border-radius: 4px;
          color: ${theme.textColorLight};
          display: flex;
          font-size: 1.4rem;
          padding: 8px 10px;
        }
        .option:not(:first-child) {
          margin-top: 10px;
        }
        .option-icon {
          margin-right: 3px;
        }
        .option-text {
          display: flex;
          flex-grow: 1;
          min-width: 0;
        }
        .option-text::before {
          counter-increment: multiplechoice-option;
          content: counter(multiplechoice-option, lower-alpha) ')';
          display: inline-block;
          margin-right: 3px;
        }
        .option-text-content {
          word-break: break-word;
        }
        .option-text-content :global(p) {
          margin: 8px 0 0;
        }
        .option-text-content :global(p:first-child) {
          margin-top: 0;
        }
        .option-correct {
          flex-grow: 0;
          flex-shrink: 0;
          font-size: 1.2rem;
          margin-left: 10px;
        }
      `}</style>
    </div>
  );
};

export default MultipleChoiceAnswer;
